
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import './Popup.scss';
import { Grid } from 'src/shared/grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, IconButton } from '@mui/material';
import {  useState } from 'react';
import { SiteMetaDataPopUp } from './sites/SiteMetaDataPopUp';
import { FieldSampleTablePopUp } from './tablesPopUp/FieldSampleTablePopUp';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useStoreContext } from 'src/store/context';
import { checkUserFieldSampleCollector } from 'src/store/common';
import { FuelsForSite } from './sites/FuelsForSite';
import { FSChartPopUp } from './chartsPopUp/FSChartPopUp';

interface PopupPropsFS {
    attributes: any,
    setSelectedSite: any,
    setPopupPosition: any,
    popupPosition: any,
}

const PopUpFieldSample: React.FC<PopupPropsFS> = ({ attributes, setSelectedSite, setPopupPosition, popupPosition, }) => {
    const [siteMeta, setSiteMeta] = useState<any>(null);
    const [state] = useStoreContext();

    const handleDragStop = (e: any, data: any) => {
        setPopupPosition({ x: data.x, y: data.y });
        localStorage.setItem('popup', JSON.stringify({ x: data.x, y: data.y }))

    };
    return (
        <Draggable
            bounds="parent"
            onStop={handleDragStop}
            defaultPosition={popupPosition}
        >
            <div
                style={{
                    backgroundColor: '#f6f6f6',
                    boxShadow: '0 .5rem 1rem 0 rgba(0,0,0,.1)',
                    color: 'black',
                    zIndex: 2001,
                    position: 'absolute',
                    cursor: 'grab',
                    maxHeight: '90vh',
                    maxWidth: '850px',
                    minWidth: '300px',
                    borderRadius: '5px',
                }}
            >
                <div style={{ position: 'absolute', right: 0, top: 0, zIndex: 800 }} >
                    <IconButton aria-label="close" onClick={() => setSelectedSite(null)}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <Grid row gap="md">
                    <Grid
                        desktop={{ col: 8 }}
                        className="display-flex flex-row flex-align-center flex-justify margin-bottom-2 padding-top-2">
                        <span
                            className="font-sans-md text-bold"
                            style={{ fontSize: '.9rem', paddingLeft: '1rem', textTransform: 'uppercase' }}
                        >
                            {attributes.name}
                        </span>
                    </Grid>
                    <Grid
                        desktop={{ col: 3 }}
                        className="display-flex flex-row flex-align-center flex-justify margin-bottom-2 padding-top-2"
                    >
                    {state.user && checkUserFieldSampleCollector(state.user) &&
                            <Button variant='text' style={{ color: 'rgb(18, 83, 147)', textTransform: 'capitalize', textDecoration: 'underline', float: 'right', fontSize: '12px' }} onClick={(e) => window.open(`/field_sample/${attributes.id}`, '_blank', 'noopener')}>
                                Go to Site<OpenInNewIcon fontSize='small' /></Button>
                        }
                    </Grid>
                </Grid>
                <div style={{ minHeight: '120px', maxWidth: '750px', maxHeight: '500px', width: '550px', overflowY: 'auto'}} className="smooth-scrollbar">
                    <Accordion id="SiteMetaData" className='accordion-style'>
                        <AccordionSummary
                            className='accordion-title-smaller'
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="SiteMetaData"
                            id="SiteMetaData"
                        >
                            Site MetaData
                        </AccordionSummary>
                        <AccordionDetails>
                            <SiteMetaDataPopUp id={attributes.id} setSiteMeta={setSiteMeta}/>
                        </AccordionDetails>
                    </Accordion>
                    <div style={{ fontWeight: 700, padding: 15 }}>FUEL SAMPLE OVERVIEW</div>
                        <FuelsForSite id={attributes.id}/>
                    <div style={{ fontWeight: 700, padding: 15 }}>FUEL CHART</div>
                    <div style={{ padding: '5px' }}>
                        <FSChartPopUp id={attributes.id} siteMeta={siteMeta}/>
                    </div>
                    <div style={{ fontWeight: 700, marginTop: '25px', padding: 15 }}>SAMPLE DATA
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        <FieldSampleTablePopUp id={attributes.id} siteMeta={siteMeta} />
                    </div>

                </div>
            </div>
        </Draggable>

    )
}

export default PopUpFieldSample;